function ContactController(){
	this.className			= "ContactController";
	this.view				= false;
	this.glob				= ["/contact**"];
	this.viewData			= {};
}
ContactController.inheritsFrom( PageController );

ContactController.prototype.on = function(onComplete){
	this.$body				= $('body');

	this.setup();

	this.contactForm = new ContactForm({
        recaptcha: this.getMeta()?.recaptcha
    });

	return true;
}
ContactController.prototype.setup = function() {
	if(this.isSetup) return;
	this.isSetup = true;
}